// Reads threshold set by Liquid snippet above
var giftThreshold = (window.giftConfig && window.giftConfig.threshold) || 0;

function toggleFreeGiftSection() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      var cartTotal = cart.total_price / 100;

      var freeGiftSection = document.getElementById('free-gift-section');
      var customFreeGift = document.getElementById('custom-free-gift');
      const freeItemDiv = document.querySelector('.custom-free-item');
      const freeGiftbuttons = document.querySelectorAll('.atc-freegift');

      if (cartTotal > giftThreshold) {
        freeGiftSection.style.display = 'block';
        freeGiftbuttons.forEach(btn => btn.classList.remove('disabled'));
      } else {
        freeGiftSection.style.display = 'none';
        if (freeItemDiv) {
          freeItemDiv.classList.add('freegift-hidden');
          freeItemDiv.remove();
        }
      }

      var freeGiftItem = cart.items.find(item => item.title.includes('Free'));

      if (freeGiftItem) {
        freeGiftSection.style.display = 'none';
        var claimedGiftText = document.querySelector('.t4s-cart__thres3');
        if (claimedGiftText) {
          claimedGiftText.innerHTML = 'Claimed Gift';
        }
        if (cartTotal < giftThreshold) {
          removeFreeGift(freeGiftItem);
        }
      } else {
        customFreeGift.style.display = 'block';
        freeGiftbuttons.forEach(btn => btn.classList.remove('disabled'));
      }
    })
    .catch(error => console.error('Error fetching cart details:', error));
}

function removeFreeGift(freeGiftItem) {
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates: { [freeGiftItem.id]: 0 } })
  })
    .then(r => r.json())
    .then(data => console.log('Item removed:', data))
    .catch(error => console.error('Error removing item from cart:', error));
}

document.addEventListener('DOMContentLoaded', function () {
  var addToCartButtons = document.querySelectorAll('.fcg-btn a');

  addToCartButtons.forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      var freeGiftVariantId = button.getAttribute('data-variant-id');
      var freeGiftSection = document.getElementById('free-gift-section');
      freeGiftSection.style.display = 'none';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: freeGiftVariantId, quantity: 1 })
      })
        .then(r => r.json())
        .then(() => {
          toggleFreeGiftSection();
          setTimeout(function () {
            var claimedGiftText = document.querySelector('.t4s-cart__thres3');
            if (claimedGiftText) {
              claimedGiftText.innerHTML = 'Claimed Gift';
            }
          }, 500);
        })
        .catch(error => console.error('Error adding free gift to cart:', error));
    });
  });

  toggleFreeGiftSection();
  document.addEventListener('cart:updated', toggleFreeGiftSection);
});